import React from 'react';
import {NavLink} from "react-router-dom";
import clsx from "clsx";

interface MobileMenuItemProps {
    text: string;
    linkTo: string;
    toggleVerticalMenu: () => void;
}

export const MobileMenuItem = ({text, linkTo, toggleVerticalMenu}: MobileMenuItemProps) => {

    return (
        <NavLink to={linkTo} className={({isActive}) => clsx(
            "h-[40px] tablet:h-[48px] text-white text-[13px] max-tablet:font-bold tablet:text-[16px] flex items-center gap-[20px] pl-[40px]",
            isActive ? "max-tablet:border-b-[2px] bg-[rgba(25,118,210,0.08)] tablet:border-r-[2px] border-[#d32f3f]" : ""
        )} onClick={toggleVerticalMenu}>
            <span/>
            <span className="">{text}</span>
        </NavLink>
    );
}
